import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import {
	L10N_CONFIG,
	L10N_LOCALE,
	L10nConfig,
	L10nLocale,
	L10nTranslatePipe,
	L10nTranslationService
} from 'angular-l10n';
import { HttpClient } from "@angular/common/http";
import { APIConfigService } from "../../api.config.service";
import { AngularMaterial2Module } from "../../app.module.material";
import { AuthService } from "../../shared/auth.service";
import { BreadcrumbService } from "../../shared/breadcrumb/breadcrumb.service";
import { LoggerService } from "../../shared/logger.service";
import { SessionService } from "../../shared/session.service";
import { RestServiceImpl } from "../immerdrin/rest.service.impl";
import { RestService } from "../immerdrin/rest.service.interface";
import { OaseDeleteDialogComponent } from "../immerdrin/oase.delete.component";
import { Tabelle } from "../immerdrin/tabelle/tabelle";
import { FormControl, FormsModule } from "@angular/forms";
import { FlexModule, MediaObserver } from "@ngbracket/ngx-layout";
import { ReplaySubject, Subject } from "rxjs";
import { ErrorHelper } from "../../shared/error.helper";
import { Antwort } from "../fragebogen/antwort.model";
import { Frage } from "../fragebogen/frage.model";
import { Fragebogen } from "../fragebogen/fragebogen.model";
import { FragenInsertEditComponent } from "./fragen.insertEdit.component";

const PATH_FILE = 'app/protected/verwaltungfragen/verwaltungfragen.component.ts';
const OBJ_LNG_NAME = 'frage';
const BACKEND_PATH_PREFIX = 'frage';

@Component({
    selector: 'oase-verwaltungfragen',
    templateUrl: './verwaltungfragen.component.html',
    providers: [{ provide: RestService, useExisting: RestServiceImpl }],
    standalone:true, imports: [AngularMaterial2Module, L10nTranslatePipe, FormsModule, RouterModule, FlexModule]

})
export class VerwaltungfragenComponent extends Tabelle<Frage> {

	elternfragen: Frage[] = Array<Frage>(); //Mögliche abhängige Fragen
	elternantworten: Antwort[] = Array<Antwort>();

	typen: string[] = new Array<string>();
	// fragebogen: Fragebogen = this.sessService.getFragebogen();
	fragebogen: Fragebogen = null;

	_selectsuche: string[] = new Array<string>();

	public filterCtl: FormControl = new FormControl();
	public selectCtl: FormControl = new FormControl();
	/** list of rechts filtered by search keyword */
	public filteredFragen: ReplaySubject<Frage[]> = new ReplaySubject<Frage[]>(1);
	maxSortierung: number = 1;

	/** Subject that emits when the component has been destroyed. */
	private _onDestroy = new Subject<void>();

	constructor(
		public route: ActivatedRoute,
		public router: Router,
		public breadcrumbService: BreadcrumbService,
		public snackBar: MatSnackBar,
		public authService: AuthService,
		public apiConfigService: APIConfigService, public http: HttpClient,
		@Inject(L10N_LOCALE) public locale: L10nLocale,
		@Inject(L10N_CONFIG) private config: L10nConfig,
		public translation: L10nTranslationService,
		public dialog: MatDialog,
		public media: MediaObserver,
		public changeDetectorRef: ChangeDetectorRef,
		public sessService: SessionService,
		public title: Title,
		public _logger: LoggerService) {

		super( route, router, breadcrumbService, snackBar,
			authService, http, translation, dialog, media, changeDetectorRef,
			sessService, title, _logger, apiConfigService, {
				OBJ_LNG_NAME: OBJ_LNG_NAME,
				BACKEND_PATH_PREFIX: BACKEND_PATH_PREFIX,
				ROUTE_NAME: "/verwaltungfragen",
				PATH_FILE: PATH_FILE,
				DEFAULT_SORT_COLUMN: "sortierung",
				extraDataForAdding: { }
			}
		);

		this.fragebogen = this.sessService.getFragebogen();

		this.breadcrumbService.addFriendlyNameForRoute('/protected/verwaltungfragebogen/verwaltungfragen', this.fragebogen.name+' - ' + this.translation.translate('frage.liste'));
		this.breadcrumbService.addFriendlyNameForRoute('/protected/verwaltungfragebogen', this.translation.translate('fragebogen.verwaltung'));

		this.displayedColumns = ['fragestellung', 'typ', 'sortierung', 'admin'];
		this.title.setTitle(this.getTitle());

	}

	getTitle() {
		return this.translation.translate('frage.title') + ' - ' + this.translation.translate('project.title');
	}

	extraInit() {
		this.getTypen();
		super.extraInit();
	}

	public afterDataIsLoaded() {
		this.maxSortierung = this.dataSource.content.length;
	}

	createNewElement() {
		return new Frage();
	}

	loeschenSpalteName() {
		return "fragestellung";
	}

	getApiParams() {
		if (this.fragebogen == null) 
			this.fragebogen = this.sessService.getFragebogen();
		return "seite/"+this.fragebogen.id;
	}

	vorHinzufuegen(element) {
		element.fragebogenId = this.fragebogen.id;
		element.typen = this.typen;
		element.maxSortierung = this.maxSortierung;
	}

	zeigeLoeschenMaske(element: any) {
		this._zeigeLoeschenMaske(element, OaseDeleteDialogComponent);
	}

	zeigeHinzufuegenMaske() {
		this._zeigeHinzufuegenMaske(FragenInsertEditComponent);
	}

	zeigeBearbeitenMaske(element) {
		element.fragebogenId = this.fragebogen.id;
		element.typen = this.typen;
		element.maxSortierung = this.maxSortierung;
		this._zeigeBearbeitenMaske(element, FragenInsertEditComponent);
	}

	// such comparison is needed for mat-select
	compareMitId(item1, item2) {
		return item1 && item2 ? item1.id === item2.id : item1 === item2;
	}

	setzeBreadcrumb(frage: Frage){
		this._logger.log(PATH_FILE + ' SETZE BREADCRUMB FRAGE');
		this.sessService.setFrage(frage);
	}// setzeBreadcrumb


	private getTypen() {
		this._logger.log(PATH_FILE + ' - getTypen Begin für URL: '+this.REST_API);

		this.http
			.get<string[]>(this.REST_API + '/getFragetypen/')
			 // Um mehrfachaufrufe zu verhindern
			.subscribe({
				next: (data) => {
					this.typen = data;
					this._logger.log(PATH_FILE + ' - getTypen End', this.typen);
				},
				error: (err) => {
					ErrorHelper.handleError(err,"Fehler beim holen der Fragebogentypen",this._logger, this.translation)
				},
				complete: () => {
					this._logger.log(PATH_FILE + ' - Holen der Fragebogentypen abgeschlossen')
				}
			});
	}//getTypen



	getElternfragen(frage) { //get Mögliche abhängige Fragen
		this._logger.log(PATH_FILE + ' - getElternfragen Begin');

		if(frage.id == undefined){
			frage.id = null;
		}

		this.http
			.get<Frage[]>(this.REST_API + '/getMoeglicheAbhaengigkeitsfragen/'+frage.id+'/'+this.fragebogen.id)
			//  // Um mehrfachaufrufe zu verhindern
			.subscribe({
				next: (data) => {
					this.elternfragen = data;
					let obj = new Frage();
					obj.fragestellung=this.translation.translate(this.OBJ_LNG_NAME+'.keineAbhaengigkeit');
					obj.id = null;
					this.elternfragen.push(obj);
					if(frage.id != null){
						if(frage.elternfrage == null){
							frage.elternfrage = obj;
						}else{
							this.getElternantworten(frage, frage.elternfrage);
						}
					}else{
						frage.elternfrage = obj;
					}
					this._logger.log(PATH_FILE + ' - getElternfragen End');
				},
				error: (err) => {
					ErrorHelper.handleError(err,"Fehler beim holen der Elternfragen",this._logger, this.translation)
				},
				complete: () => {
					this._logger.log(PATH_FILE + ' - Holen der Elternfragen abgeschlossen')
				}
			});
	} // getElternfragen


	private getElternantworten(frage: Frage, elternfrage: Frage){
		this._logger.log(PATH_FILE + ' - getElternantworten Begin');

		this.http
			.get<Antwort[]>(this.apiConfigService.REST_API_BASE() + 'antwort/liste/'+elternfrage.id)
			//  // Um mehrfachaufrufe zu verhindern
			.subscribe({
				next: (data) => {
					this.elternantworten = data;
					if(frage.id != null && frage.elternfrage != null && frage.elternantworten.length > 0){
						for(const currentElternAntwort of frage.elternantworten){
							let index = this.elternantworten.findIndex(a => a.id == currentElternAntwort.id);
							if(index > -1){
								this.elternantworten[index].selected = true;
								this.elternantworten[index].sollGewaehlt = currentElternAntwort.sollGewaehlt;
							}
						}
					}
					this._logger.log(PATH_FILE + ' - getElternantworten End');
				},
				error: (err) => {
					ErrorHelper.handleError(err,"Fehler beim holen der Elternantworten",this._logger, this.translation)
				},
				complete: () => {
					this._logger.log(PATH_FILE + ' - Holen der Elternantworten abgeschlossen')
				}
			});
	}// getElternantworten
}